import api from "./api"

const baseUrl = 'visit'

export const getLastVisitDate = (): Promise<any> => {
  return api.get(`${baseUrl}/last-date`).then(res => res)
}

export const recordVisit = () => {
  return api.post(`${baseUrl}`)
}

export const getVisitStats = (from: string, to: string) => {
  return api.get(`${baseUrl}/stats`, { params: { from, to } }).then(res => res)
}